import { render, staticRenderFns } from "./quesPlay3.vue?vue&type=template&id=655e1804"
import script from "./quesPlay3.vue?vue&type=script&lang=js"
export * from "./quesPlay3.vue?vue&type=script&lang=js"
import style0 from "./quesPlay3.vue?vue&type=style&index=0&id=655e1804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports